import { useTranslations } from '@vocab/react';
import { Box, Stack, Heading, Strong } from 'braid-design-system';
import type React from 'react';

import {
  IconPromoteText,
  IconTickText,
} from 'src/App/components/TextWithIcon/TextWithIcon';

import { useAppContext } from '../../../../context/AppContext';
import { isAnz } from '../../../../utils/isAnz';
import type { AdBudgetInfo } from '../../context/reducer';

import translations from './.vocab';

interface SellingPointsProps {
  readonly adBudgetInfo: AdBudgetInfo;
}
const SellingPoints: React.FC<React.PropsWithChildren<SellingPointsProps>> = ({
  adBudgetInfo,
}: SellingPointsProps) => {
  const { t } = useTranslations(translations);

  const { country } = useAppContext();
  const brandedFeaturesLabel = isAnz(country) ? 'StandOut' : 'Branded Ad';

  return (
    <Box padding="large" background="surface">
      <Box marginBottom="large">
        <Heading level="3">{t('your ad budget')}</Heading>
      </Box>
      <Stack space="small">
        <IconTickText>
          {t('use your ad budget balance to post...')}
        </IconTickText>
        <IconTickText>
          {t('your budget will activate after purchase...')}
        </IconTickText>
        {/* TODO DYM update translations and copy for 2.2.1 */}
        {adBudgetInfo.ads === 'PREMIUM_ONLY' ? (
          <IconTickText>
            {t('discount applies only when the ad budget is still active')}
          </IconTickText>
        ) : (
          <IconTickText>
            {t('discount applies for your contract term...')}
          </IconTickText>
        )}
        {adBudgetInfo.ads === 'BRANDED_ONWARDS' && (
          <IconPromoteText>
            <Strong>
              {t(
                'all of your ads will include {brandedFeaturesLabel} features',
                {
                  brandedFeaturesLabel,
                },
              )}
            </Strong>
          </IconPromoteText>
        )}
        {/* TODO DYM update translations and copy for 2.2.1 */}
        {adBudgetInfo.ads === 'PREMIUM_ONLY' && (
          <IconPromoteText>
            <Strong>
              {t('budget can only be used for Premium Ad posting')}
            </Strong>
          </IconPromoteText>
        )}
      </Stack>
    </Box>
  );
};

export default SellingPoints;
